// extracted by mini-css-extract-plugin
module.exports = {"sign-up-button":"SignUpButton_sign-up-button__HX8RZ","mobile-btn":"SignUpButton_mobile-btn__GPpsX"};